import { Switch, SwitchProps } from '@mui/base';
import s from './styles.scss';

const Toggle = (props: SwitchProps) => {
  return (
    <Switch
      {...props}
      slotProps={{
        root: { className: s.toggle },
        input: { className: s.invisible },
        thumb: { className: s.thumb },
        track: { className: s.track },
      }}
    />
  );
};

export { Toggle, SwitchProps as Props };
